/* eslint-disable no-loop-func */
import moment from "moment";
import { SLIDER_MARGIN } from "./Constants";

export const IsNumberFloatKey = (value) => {
    return value.match(/^\d{1,}(\.\d{0,2})?$/) ? true : false;
};

export const IsNumberKey = (value) => {
    return value.match(/^[0-9\b]+$/) ? true : false;
};

export const  formatDate = (date) => {

    return moment(date).format("MM/DD/YYYY");
};
export const FormatAmount = (str) => {
   // Ensure str is a number
  const num = parseFloat(str);

  // Handle invalid or missing numbers
  if (isNaN(num)) return "0";

  const rounded = Math.round(num);

    return rounded.toString().replace(/\b(\d+)((\.\d+)*)\b/g, function (a, b, c) {
        return (
            (b.charAt(0) > 0 && !(c || ".").lastIndexOf(".")
                ? b.replace(/(\d)(?=(\d{3})+$)/g, "$1,")
                : b) + c
        );
    });
};

export const calculateValueInPercent = (
    amount,
    per,
    marginAddSubtractValue
) => {
    // marginAddSubtractValue 0 means subtract from original amount
    // marginAddSubtractValue 1 means subtract from original amount
    if (marginAddSubtractValue === 0)
        return parseInt(amount - (amount / 100) * per);
    else return parseInt(amount + (amount / 100) * per);
};

// function doCalculation() {
//     //set purchase price
//     // setPurchasePrice(downPayment, downPaymentPercent);
//     //To update the value of purchase price slider
//     ppValue = parseInt(purchasePrice);

//     //To update the value of down payment slider
//     amtValue = parseInt(downPayment);

//     var propertyTaxes = (purchasePrice * propertyTax) / 100;

//     //Mortgage Structure calculation
//     var loanPercent = 100 - downPaymentPercent;
//     var firstLoanPercent = loanPercent - secondLoanPercent;
//     var firstLoanAmt = parseFloat(
//         ((purchasePrice * firstLoanPercent) / 100).toFixed(0)
//     );
//     var secondLoanAmt = parseFloat(
//         ((purchasePrice * secondLoanPercent) / 100).toFixed(0)
//     );
//     var firstLoanAmttmp = firstLoanAmt;
//     if (firstLoanAmt >= 1000000) {
//         firstLoanAmttmp = 1000000;
//     }

//     var secondLoanAmt = parseFloat(
//         ((purchasePrice * secondLoanPercent) / 100).toFixed(0)
//     );
//     var secondLoanAmttmp = secondLoanAmt;
//     if (secondLoanAmt >= 100000) {
//         secondLoanAmttmp = 100000;
//     }
//     var first = Math.round(
//         pmt(
//             firstLoanInterestRate / 1200, // Annual interest into months
//             years * 12, // Total months for life of loan
//             firstLoanAmt,
//             0,
//             0
//         ) * -1
//     );

//     var second = Math.round(
//         pmt(
//             secondLoanInterestRate / 1200, // Annual interest into months
//             years * 12, // Total months for life of loan
//             secondLoanAmt,
//             0,
//             0
//         ) * -1
//     );

//     var mortgageTotal = first + second;
//     var mortgagePayment = parseFloat((first + second + HOA).toFixed(0));

//     //Deductible Expenses calculation
//     var interestOnFirst = parseFloat(
//         ((firstLoanAmttmp * firstLoanInterestRate) / 1200).toFixed(0)
//     );
//     var interestOnSecond = parseFloat(
//         ((secondLoanAmttmp * secondLoanInterestRate) / 1200).toFixed(0)
//     );
//     var interestOnFirstprincipal = parseFloat(
//         ((firstLoanAmt * firstLoanInterestRate) / 1200).toFixed(0)
//     );
//     var interestOnSecondprincipal = parseFloat(
//         ((secondLoanAmt * secondLoanInterestRate) / 1200).toFixed(0)
//     );
//     var dedPropertyTax = parseFloat(
//         ((purchasePrice * propertyTax) / 1200).toFixed(0)
//     );
//     var total = parseFloat(
//         (interestOnFirst + interestOnSecond + dedPropertyTax).toFixed(0)
//     );
//     total = parseFloat(total.toFixed(0));

//     var taxBreak = parseFloat(((total * (fed + state)) / 100).toFixed(0));

//     var PrincipalRepaid = parseFloat(
//         (
//             first -
//             interestOnFirstprincipal +
//             second -
//             interestOnSecondprincipal
//         ).toFixed(0)
//     );
//     PrincipalRepaid = parseFloat(PrincipalRepaid.toFixed(0));
//     var netExpense =
//         parseFloat((mortgagePayment - taxBreak - PrincipalRepaid).toFixed(0)) ||
//         "";
//     var proratedMonthlyExpense = parseFloat(
//         ((insurance + homewarranty) / 12 + dedPropertyTax).toFixed(0)
//     );
//     var totalMonthlyExpense =
//         parseFloat((netExpense + proratedMonthlyExpense).toFixed(0)) || "";

//     var totalMonthlyPayment = mortgagePayment;
//     //To store old value in variable
//     dDPorg = downPaymentPercent;
//     pTOrg = propertyTax;
//     hOAOrg = HOA;
//     fTOrg = fed;
//     sTOrg = state;
//     insuranceOrg = insurance;
//     homewarrantyOrg = homewarranty;
//     sLIOrg = secondLoanInterestRate;
// }
// Clear all calculations in case of invalid value

export const getPurchasePrice = (downPayment, downPaymentPercent) => {
    // downPayment = downPayment.replace(/\,/g, "");
    var calPurchasePrice = parseInt(
        (downPayment * 100) / downPaymentPercent
    ).toFixed(0);
    // calPurchasePrice = calPurchasePrice;
    // if (calPurchasePrice === "NaN" || calPurchasePrice === NaN)
    //     calPurchasePrice = "";

    if (calPurchasePrice === "NaN" || isNaN(calPurchasePrice))
    //     calPurchasePrice = "";

    return Number(calPurchasePrice);
};
//For setting Purchase Price
// export const setPurchasePrice = (downPayment, downPaymentPercent) => {
//     var calPurchasePrice = parseInt(
//         (downPayment * 100) / downPaymentPercent
//     ).toFixed(0);
//     calPurchasePrice = FormatAmount(calPurchasePrice);
//     return calPurchasePrice;
// };
//For getting down payment
export const getDownPayment = (purchasePrice, downPaymentPercent) => {
    const downPayment = parseInt((Number(purchasePrice) * Number(downPaymentPercent)) / 100);
    return downPayment;
};

//To calculate Down payment in percent
export const getDownPaymentPercent = (downPayment, downPurchasePrice) => {
    const calDownPaymentPercent = (downPayment * 100) / downPurchasePrice;
    return parseInt(calDownPaymentPercent);
};

export const PMT = (rate_per_period, number_of_payments, present_value, future_value, type) => {
    if(rate_per_period !== 0.0){
        // Interest rate exists
        var q = Math.pow(1 + rate_per_period, number_of_payments);
        return -(rate_per_period * (future_value + (q * present_value))) / ((-1 + q) * (1 + rate_per_period * (type)));

    } else if(number_of_payments !== 0.0){
        // No interest rate, but number of payments exists
        return -(future_value + present_value) / number_of_payments;
    }
    return 0;
}

export const IPMT = (present_value, pmt, rate, per) => {
    var tmp = Math.pow(1 + rate, per);
    return 0 - (present_value * tmp * rate + pmt * (tmp - 1));
};

export const validateEmail = (email) => {
    const re = /^[A-Z0-9]+[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    return re.test(email);
};

export const getPropertyTaxes = (taxType, purchasePrice, propertyTax, maxPropertyTax, allowCapProperty = false) => {
    let calculatedPropertyTax =
        Number(purchasePrice) * (Number(propertyTax) / 100);

    if(allowCapProperty) {
        if(calculatedPropertyTax > maxPropertyTax) {
            calculatedPropertyTax = maxPropertyTax;
        }
    }
    if(taxType === "Annual") {
        return parseFloat(calculatedPropertyTax).toFixed(0);
    } else {
        return parseFloat(calculatedPropertyTax/12).toFixed(2);
    }
}

export const replaceCommaInNumber = (number) => {
    return number.replace(",",'');
}

export const SETTINGS_CONSTANT_OBJECT = {
    amortizationYears: 30,
    secondAmortizationYears: 12,
    taxDeductionOnFirst: 750000,
    taxDeductionOnSecond: 0,
    stateTaxRate: 9,
    federalTaxRate: 24,
    propertyTax: 1.25,
    capItemizationPropertyTax: 40000,
    standardDeduction: 25900,
    rentalIncrease: 10,
    averageAppreciation: 7,
    inflationRate: 3,
    increasePropertyTax: 2,
    interestOnEquity: 4
};

export const convertSettingToNumber = (record) => {
    const obj = {
        id: Number(record?.id),
        amortizationYears: Number(record?.amortizationYears),
        secondAmortizationYears: Number(record?.secondAmortizationYears)
            ? Number(record?.secondAmortizationYears)
            : 12,
        taxDeductionOnFirst: Number(record?.taxDeductionOnFirst),
        taxDeductionOnSecond: Number(record?.taxDeductionOnSecond),
        stateTaxRate: Number(record?.stateTaxRate),
        federalTaxRate: Number(record?.federalTaxRate),
        propertyTax: Number(record?.propertyTax),
        capItemizationPropertyTax: Number(record?.capItemizationPropertyTax),
        standardDeduction: Number(record?.standardDeduction),
        userId: Number(record?.userId),
        rentalIncrease: Number(record?.rentalIncrease),
        averageAppreciation: Number(record?.averageAppreciation),
        increasePropertyTax: Number(record?.increasePropertyTax),
        inflationRate: Number(record?.inflationRate),
        interestOnEquity: Number(record?.interestOnEquity)
    };
    return obj;
}

export const setSessionUserSettings = (userSettings) => {
    sessionStorage.setItem('userSettings',JSON.stringify(userSettings));
}

export const getSessionUserSettings = () => {
    return JSON.parse(sessionStorage.getItem('userSettings'));
}

export const setSessionUserInformation = (userInfo) => {
    sessionStorage.setItem('user',JSON.stringify(userInfo));
}

export const setSessionBrokerInformation = (userInfo) => {
    sessionStorage.setItem('brokerInfo',JSON.stringify(userInfo));
}

export const setSessionAgentInformation = (userInfo) => {
    sessionStorage.setItem('agentInfo',JSON.stringify(userInfo));
}

export const getSessionAgentInformation  = () => {
    return JSON.parse(sessionStorage.getItem('agentInfo'));
}

export const getSessionBrokerInformation  = () => {
    return JSON.parse(sessionStorage.getItem('brokerInfo'));
}

export const getSessionUserInformation = () => {
    return JSON.parse(sessionStorage.getItem('user'));
}

export const setSessionClientSettings = (clientSettings) => {
    sessionStorage.setItem('clientSettings',JSON.stringify(clientSettings));
}

export const getSessionClientSettings = () => {
    return JSON.parse(sessionStorage.getItem('clientSettings'));
}

export const setSessionClientInformation = (clientInfo) => {
    sessionStorage.setItem('clientInfo',JSON.stringify(clientInfo));
}

export const getSessionClientInformation = () => {
    return JSON.parse(sessionStorage.getItem('clientInfo'));
}

export const convertStringToNumberObject = (object) => {
    
    const entries =  Object.keys(object).map(key => {
        return isNaN(object[key]) ? [key, object[key]] :  [key, Number(object[key])];

    });
    return Object.fromEntries(new Map(entries));
}

export const getMinMaxValueSlider = (value) => {
    let ppMin = calculateValueInPercent(value, SLIDER_MARGIN, 0);
    let ppMax = calculateValueInPercent(value, SLIDER_MARGIN, 1);
    return { ppMin, ppMax };
};

export const handleFetchedLeftValues = (searchParams, sessionValues) => {
    let getParameters = {};
    let monthlyMortgageStrucuture = {};
    if (!!sessionValues?.rent === false) {
        if (searchParams.rent) {
            getParameters.rent = replaceCommaInNumber(
                searchParams.rent
            );
        }
        if (searchParams.downPayment) {
            getParameters.downPayment = Number(
                searchParams.downPayment
            );
            const minMaxValue = getMinMaxValueSlider(getParameters.downPayment);
            getParameters.minDownPayment = minMaxValue?.ppMin;
            getParameters.maxDownPayment = minMaxValue?.ppMax;
        }
        if (searchParams.downPaymentPercent) {
            getParameters.downPaymentPercent = Number(
                searchParams.downPaymentPercent
            );
            getParameters.minDownPaymentPercent = 3.5;
            getParameters.maxDownPaymentPercent = 100;
            getParameters.firstLoanPercent =
                100 - getParameters.downPaymentPercent;
        }
        if (searchParams.purchasePrice) {
            getParameters.purchasePrice = Number(
                searchParams.purchasePrice
            );

            const minMaxValue = getMinMaxValueSlider(getParameters.purchasePrice);

            getParameters.minPurchasePrice = minMaxValue?.ppMin;
            getParameters.maxPurchasePrice = minMaxValue?.ppMax;
            monthlyMortgageStrucuture.firstLoanPrincipal =
                getParameters.purchasePrice - getParameters.downPayment;
            // monthlyExpensesValues.firstLoanAmount = parseFloat()
        }
        getParameters.secondLoanInterestRate = 0;
        getParameters.secondLoanPercent = 0;
        // getParameters.firstLoanInterestRate = FIRST_LOAN_RATE;
    } else {
        if (!!sessionValues.rent) {
            getParameters.rent = sessionValues.rent;
        }
        if (!!sessionValues.downPayment) {
            getParameters.downPayment = Number(sessionValues.downPayment);
            const minMaxValue = getMinMaxValueSlider(getParameters.downPayment);
            getParameters.minDownPayment = minMaxValue?.ppMin;
            getParameters.maxDownPayment = minMaxValue?.ppMax;
        }
        if (!!sessionValues.downPaymentPercent) {
            getParameters.downPaymentPercent = Number(
                sessionValues.downPaymentPercent
            );
            getParameters.minDownPaymentPercent = 3.5;
            getParameters.maxDownPaymentPercent = 100;
            getParameters.firstLoanPercent =
                100 - getParameters.downPaymentPercent;
        }
        if (!!sessionValues.purchasePrice) {
            getParameters.purchasePrice = Number(
                sessionValues.purchasePrice
            );

            const minMaxValue = getMinMaxValueSlider(getParameters.purchasePrice);

            getParameters.minPurchasePrice = minMaxValue?.ppMin;
            getParameters.maxPurchasePrice = minMaxValue?.ppMax;
            monthlyMortgageStrucuture.firstLoanPrincipal =
                getParameters.purchasePrice - getParameters.downPayment;
            // monthlyExpensesValues.firstLoanAmount = parseFloat()
        }
        getParameters.secondLoanInterestRate = 0;
        getParameters.secondLoanPercent = 0;
        // getParameters.firstLoanInterestRate = FIRST_LOAN_RATE;
    }
    getParameters.zipCode = sessionValues?.zipcode;
    return getParameters;
}

export  const calcDebtPaymentsCalculations = (newValues) => {
    let {
        selfAutoLoan,
        selfStudentLoan,
        selfCreditCards,
        selfMortgage,
        selfOther,
        spouseAutoLoan,
        spouseStudentLoan,
        spouseCreditCards,
        spouseMortgage,
        spouseOther,
    } = newValues;
    // Addition of Self Debt Payments
    newValues.selfTotalDebtPayments =
    selfAutoLoan + selfStudentLoan + selfCreditCards + selfMortgage + selfOther;

    // //Addition of Spouse Debt Payments
    newValues.spouseTotalDebtPayments =
        spouseAutoLoan +
        spouseStudentLoan +
        spouseCreditCards +
        spouseMortgage +
        spouseOther;

    // // Addition of Self and Spouse Debt Payments

    newValues.totalDebtPayments =
        newValues.selfTotalDebtPayments + newValues.spouseTotalDebtPayments;
    return newValues;
} 

export const statusList = () => {
    return [
        {
            status: "Active",
        },
        {
            status: "Inactive",
        },
        {
            status: "Approval Pending",
        },
    ];
};
export const statusListBroker = () => {
    return [
        {
            status: "Active",
        },
        {
            status: "Inactive",
        },
        {
            status: "Registration Pending",
        },
    ];
};
export const subTypeList = () => {
    return [
       
        {
            subscriptionType: "Approved",
        },
        {
            subscriptionType: "Rejected",
        },
    ];
};


export const getActualPropertyTax = (purchasePrice, propertyTax) => {
    let calculatedPropertyTax =
        purchasePrice * (propertyTax / 100);
    if(calculatedPropertyTax <= 0) {
        return 0;
    } else {
        return parseInt(calculatedPropertyTax);
    }
}
export const calculateLoanValues = (principal,annualRate,years,loanStartDate, isFirst) => {

    const monthlyRate = (annualRate / 100) / 12;
    const totalMonths = years  * 12;
    const payment = !principal || principal === 0 ? 0 : (principal * monthlyRate * Math.pow(1 + monthlyRate, totalMonths)) / (Math.pow(1 + monthlyRate, totalMonths) - 1);

    let remainingBalance = Number(principal) || 0;
    let yearly = [];
    let every3Years = [];
    let yearlyPrincipalPaid = []; 
    let loanStartYear = Number(moment().format("YYYY"))
    if(isFirst)
        loanStartYear = loanStartDate ? new Date(loanStartDate).getFullYear()  : Number(moment().format("YYYY"));    
    else
        loanStartYear = loanStartDate ? new Date(loanStartDate).getFullYear(): Number(moment().format("YYYY"));    
    // Start yearly entries from the year after loan start (end of first year)
    let currentYear = loanStartYear + 1;
    const maxYear = currentYear + 30;

    // Compute loan balance every year & every 3 years
    let month = 0;
    let principalPaidThisYear = 0;
     for (let month = 0; month < totalMonths; month++) {
        
      // Record end-of-year balances starting after the first 12 months
      if (month % 36 === 0 || month === 0) every3Years.push([month / 12, Number(remainingBalance)]);

      // Amortization calculation
      let interestPayment = remainingBalance * monthlyRate;
      let principalPayment = payment - interestPayment;
       principalPayment = Math.min(principalPayment, remainingBalance);
      remainingBalance -= principalPayment;
      principalPaidThisYear += principalPayment;
      if ((month + 1) % 12 === 0 || month === totalMonths - 1) {
            yearly[currentYear - 1] = Number(remainingBalance.toFixed(2));
            yearlyPrincipalPaid[currentYear - 1] = Number(principalPaidThisYear.toFixed(2));

            currentYear++;
            principalPaidThisYear = 0;
        }
    }
    
    return { yearly, every3Years, yearlyPrincipalPaid};
}
export const getRentOwnedEstateRecords = (userRecord,expensesRecord,userSettings) => {
    let reportData = [];
    let rentData = [];
    let annualData = [];
    let labels = [];
    let totalEquityList = [];
    let appreciationList = [];
    let totalHomeValue = [];

    const rentalIncrease = Number(userSettings?.rentalIncrease) ? Number(userSettings?.rentalIncrease) : 10;
    const inflationRate =  Number(userSettings?.inflationRate) ? Number(userSettings?.inflationRate) : 3;
    const increasePropertyTax =  Number(userSettings?.increasePropertyTax) ? Number(userSettings?.increasePropertyTax) : 2;
    const averageAppreciation =  Number(userSettings?.averageAppreciation) ? Number(userSettings?.averageAppreciation) : 7;

    if (userRecord && expensesRecord && userSettings) {
        const pTax = getPropertyTaxes(
            "Annual",
            Number(userRecord?.purchasePrice),
            Number(userSettings?.propertyTax),
            Number(userSettings?.capItemizationPropertyTax),
            true
        );
        const currentYear = Number(moment().format("YYYY"));
        const maxYear = currentYear + 30;
        for (let i = currentYear; i <= maxYear; i++) {
            let obj = {};
            obj.year = i;
            if (i === currentYear) {
                obj.rent = Number(userRecord?.rent).toFixed(0);
                obj.annualRent = Number(userRecord?.rent) * 12;
                obj.mortgage = Number(
                    expensesRecord?.mortgageExpenseRecord?.totalExpense
                );
                obj.propertyTax =
                    Number(pTax) +
                    Number(
                        expensesRecord?.taxExpenseRecord
                            ?.nonDeductiblePropertyTax
                    ) *
                        12;
                obj.expenses = (
                    (Number(expensesRecord?.annualExpenseRecord?.insurance) +
                        Number(
                            expensesRecord?.annualExpenseRecord?.homeWarranty
                        )) /
                        12 +
                    Number(expensesRecord?.mortgageExpenseRecord?.hoa)
                ).toFixed(0);
                obj.annualExpense =
                    Number(obj.mortgage) * 12 +
                    Number(obj.propertyTax) +
                    Number(obj.expenses) * 12;
                obj.mid = Number(
                    expensesRecord?.taxExpenseRecord?.annualTaxBreak
                );
                obj.nett = obj.annualExpense - obj.mid;
                obj.appreciation =
                    Number(userRecord?.purchasePrice) *
                    (Number(averageAppreciation) / 100);
                obj.beforeTotalEquity =  Number(obj.appreciation) - Number(obj.nett);
                obj.totalEquity = Number(obj.annualRent) + Number(obj.beforeTotalEquity);
                obj.totalHomeValue = Number(obj.appreciation) + Number(userRecord?.purchasePrice);
                reportData.push(obj);
                rentData.push(Number(obj.annualRent));
                annualData.push(obj.annualExpense);
                // labels.push(Number(obj.annualRent));
                appreciationList.push(Number(obj.appreciation));
                totalEquityList.push(Number(obj.totalEquity));
                totalHomeValue.push(Number(obj.totalHomeValue))
                labels.push(Number(i));
            } else {
                let oldRecord = reportData.find((rd) => rd.year === i - 1);
                
                obj.rent = (
                    Number(oldRecord?.rent) +
                    Number(oldRecord?.rent) * (rentalIncrease / 100)
                ).toFixed(0);
                obj.annualRent = (obj.rent * 12).toFixed(0);
                obj.mortgage = Number(
                    expensesRecord?.mortgageExpenseRecord?.totalExpense
                );
                obj.propertyTax = parseInt(
                    Number(oldRecord.propertyTax) *
                        (1 + increasePropertyTax / 100)
                );
                obj.expenses = (
                    Number(oldRecord.expenses) *
                    (1 + inflationRate / 100)
                ).toFixed();
                obj.annualExpense =
                    Number(obj.mortgage) * 12 +
                    Number(obj.propertyTax) +
                    Number(obj.expenses) * 12;

                obj.mid = Number(
                    expensesRecord?.taxExpenseRecord?.annualTaxBreak
                );
                obj.nett = obj.annualExpense - obj.mid;
                obj.appreciation = (
                    Number(oldRecord?.appreciation) +
                    Number(oldRecord?.appreciation) *
                        (averageAppreciation / 100)
                ).toFixed();
                obj.beforeTotalEquity =   Number(obj.appreciation) - Number(obj.nett);
                obj.totalEquity = Number(obj.annualRent) + Number(obj.beforeTotalEquity);
                obj.totalHomeValue = Number(oldRecord?.totalHomeValue) + Number(obj.appreciation);

                reportData.push(obj);
                rentData.push(Number(obj.annualRent));
                annualData.push(obj.annualExpense);
                appreciationList.push(Number(obj.appreciation));
                totalEquityList.push(Number(obj.totalEquity));
                totalHomeValue.push(Number(obj.totalHomeValue))
                // labels.push(Number(obj.annualRent));
                labels.push(Number(i));
            }
        }

        return { reportData, rentData, annualData, labels, totalEquityList, appreciationList, totalHomeValue };
    }
}

export const getRentOwnedEstateRecordsInvestment = (userRecord,assumptionsInput,purchasePriceInfo,userSettings) => {
    let reportData = [];
    let rentData = [];
    let annualData = [];
    let labels = [];
    let totalEquityList = [];
    let appreciationList = [];
    let totalHomeValue = [];

    const rentalIncrease = Number(assumptionsInput?.rentalIncrease) ? Number(assumptionsInput?.rentalIncrease) : 10;
    const inflationRate =  Number(assumptionsInput?.inflationRate) ? Number(assumptionsInput?.inflationRate) : 3;
    const increasePropertyTax =  Number(assumptionsInput?.increasePropertyTax) ? Number(assumptionsInput?.increasePropertyTax) : 2;
    const averageAppreciation =  Number(assumptionsInput?.appreciation) ? Number(assumptionsInput?.appreciation) : 7;

    let loanValues = calculateLoanValues(purchasePriceInfo?.mortgage,purchasePriceInfo?.interestRate,assumptionsInput?.amortization);
    if (userRecord && purchasePriceInfo && assumptionsInput) {
        const pTax = getPropertyTaxes(
            "Annual",
            Number(purchasePriceInfo?.purchasePrice),
            Number(purchasePriceInfo?.propertyTaxes),
            Number(userSettings?.capItemizationPropertyTax),
            true
        );
        const currentYear = Number(moment().format("YYYY"));
        const maxYear = currentYear + 30;
        for (let i = currentYear; i <= maxYear; i++) {
            let obj = {};
            obj.year = i;
            if (i === currentYear) {
                obj.rent = Number(purchasePriceInfo?.monthlyRent).toFixed(0);
                obj.annualRent = Number(purchasePriceInfo?.monthlyRent) * 12;
                obj.mortgage = Number(
                    purchasePriceInfo?.expenses_operatingexpenses
                );
                if(assumptionsInput?.cap == "Yes") {
                    obj.propertyTax =
                    Number(purchasePriceInfo?.purchasePrice) * (1+Number(assumptionsInput?.cap_rate)/100);
                } else {
                    obj.propertyTax = Number(purchasePriceInfo?.purchasePrice) * assumptionsInput?.propertyTaxRate/100
                }
                obj.expenses = 
                    (Number(purchasePriceInfo?.expenses_insurance) +
                    Number(purchasePriceInfo?.expenses_hoa)
                ).toFixed(0);
                obj.annualExpense =
                    Number(obj.mortgage) * 12 +
                    Number(obj.propertyTax) +
                    Number(obj.expenses) * 12;
               /* obj.mid = Number(
                    expensesRecord?.taxExpenseRecord?.annualTaxBreak
                );
                obj.nett = obj.annualExpense - obj.mid;*/
                obj.appreciation =
                    Number(purchasePriceInfo?.purchasePrice) *
                    (Number(averageAppreciation) / 100);
                //obj.beforeTotalEquity =  Number(obj.appreciation) - Number(obj.nett);
                //obj.totalEquity = Number(obj.annualRent) + Number(obj.beforeTotalEquity);
                obj.totalHomeValue = Number(obj.appreciation) + Number(purchasePriceInfo?.purchasePrice);
                obj.loanAmount = loanValues.yearly[i];
                reportData.push(obj);
                rentData.push(Number(obj.annualRent));
                annualData.push(obj.annualExpense);
                // labels.push(Number(obj.annualRent));
                appreciationList.push(Number(obj.appreciation));
               // totalEquityList.push(Number(obj.totalEquity));
                totalHomeValue.push(Number(obj.totalHomeValue))
                labels.push(Number(i));
            } else {
                let oldRecord = reportData.find((rd) => rd.year === i - 1);
                
                obj.rent = (
                    Number(oldRecord?.rent) +
                    Number(oldRecord?.rent) * (rentalIncrease / 100)
                ).toFixed(0);
                obj.annualRent = (obj.rent * 12).toFixed(0);
                obj.mortgage = Number(
                    purchasePriceInfo?.expenses_operatingexpenses
                );
                if(assumptionsInput?.cap == "Yes") {
                    obj.propertyTax =
                        Number(oldRecord.propertyTax) *
                        (1 + Number(assumptionsInput?.cap_rate)/100)
                } else {
                    obj.propertyTax = parseInt(
                        Number(oldRecord.propertyTax) *
                            (1 + increasePropertyTax / 100)
                    );
                }

                
                obj.expenses = (
                    Number(oldRecord.expenses) *
                    (1 + inflationRate / 100)
                ).toFixed();
                obj.annualExpense =
                    Number(obj.mortgage) * 12 +
                    Number(obj.propertyTax) +
                    Number(obj.expenses) * 12;

               /* obj.mid = Number(
                    expensesRecord?.taxExpenseRecord?.annualTaxBreak
                );
                obj.nett = obj.annualExpense - obj.mid;*/
                obj.appreciation = (
                    Number(oldRecord?.appreciation) +
                    Number(oldRecord?.appreciation) *
                        (averageAppreciation / 100)
                ).toFixed();
                //obj.beforeTotalEquity =  Number(oldRecord?.appreciation) + Number(obj.appreciation) - Number(obj.nett);
                //obj.totalEquity = Number(obj.annualRent) + Number(obj.beforeTotalEquity);
                obj.totalHomeValue = Number(oldRecord?.totalHomeValue) + Number(obj.appreciation);
                obj.loanAmount = loanValues.yearly[i];
                reportData.push(obj);
                rentData.push(Number(obj.annualRent));
                annualData.push(obj.annualExpense);
                appreciationList.push(Number(obj.appreciation));
                //totalEquityList.push(Number(obj.totalEquity));
                totalHomeValue.push(Number(obj.totalHomeValue))
                // labels.push(Number(obj.annualRent));
                labels.push(Number(i));
            }
        }

        return { reportData, rentData, annualData, labels, totalEquityList, appreciationList, totalHomeValue };
    }
}
export const getPortfolioRecords = (data,appreciation,pDate) => {

    let reportData = [];
    let totalHomeValue = [];
    let labels = [];
    const currentYear = Number(moment().format("YYYY"));
    const maxYear = currentYear + 30;
    for (let i = currentYear; i <= maxYear; i++) { //to be changed
        let obj = {};
        obj.year = i;
        const purchaseYear = pDate
                        ? new Date(pDate).getFullYear()
                        : currentYear;

        let years = 0;
        if(purchaseYear != null && currentYear > purchaseYear) {
            years= i - purchaseYear; 
        } else {
            years = i - currentYear;
        }
        const valueToday = data * Math.pow(1 + appreciation / 100, years);
        
        if (i === currentYear) {
            obj.finalVal = valueToday;
            totalHomeValue.push(Number(obj.finalVal))
            reportData.push(obj);
            labels.push(String(i));
        } else {
            // For future years, calculate from original purchase value
            obj.finalVal = valueToday;
            totalHomeValue.push(Number(obj.finalVal));
            reportData.push(obj);
            labels.push(String(i));
        }
    }
        return {totalHomeValue,labels};
    }
export const getConvertedFileName = (fileName) => {
    if (fileName) {
        const splitFileName = fileName.replace(/\s/g, "-").toLowerCase().split(".");
        const newSplitFileName = `${splitFileName[0]}${Date.now()}.${
            splitFileName[splitFileName.length - 1]
        }`;
        return newSplitFileName
    }
}

export const getDirectIncomeCalculations = (payload) => {
    let newDirectIncome = {
        selfGrossPreTaxSalary: payload?.selfIncome
            ? (Number(payload?.selfIncome) / 12).toFixed()
            : 0,
        spouseGrossPreTaxSalary: payload?.spouseIncome
            ? (Number(payload?.spouseIncome) / 12).toFixed()
            : 0,
        selfBonus: payload?.others
            ? (Number(payload?.others) / 12).toFixed()
            : 0,
        spouseBonus: 0,
        selfCommissions: 0,
        spouseCommissions: 0,
        spouseOverTime: 0,
        selfOverTime: 0,
    };

    newDirectIncome.selfDirectIncome =
        Number(newDirectIncome.selfGrossPreTaxSalary) +
        Number(newDirectIncome.selfBonus);
    newDirectIncome.spouseDirectIncome =
            Number(newDirectIncome.spouseGrossPreTaxSalary) +
            Number(newDirectIncome.spouseBonus);
    newDirectIncome.totalDirectIncome =
        Number(newDirectIncome.selfDirectIncome) +
        Number(newDirectIncome.spouseDirectIncome); 

        return newDirectIncome;
}

export const iterateRatios = (
    purchasePrice,
    totalMonthly,
    annualExpenseValues,
    directIncome,
    indirectIncome,
    debtPayments,
    propertyTax
) => {
    let frontRatio = 0;
    let backRatio = 0;
    // frontRatio = totalMortgagePayment + acutalpropertyTax/12 + homeInsurace/12
    const commonAddition =
        Number(totalMonthly) +
        Number(getActualPropertyTax(purchasePrice,propertyTax) / 12) +
        Number(annualExpenseValues?.insurance / 12);
    const totalGrossIncome =
        Number(directIncome?.totalDirectIncome) +
        Number(indirectIncome?.totalIndirectIncome);

    if (totalGrossIncome > 0 && commonAddition > 0) {
        frontRatio = commonAddition / totalGrossIncome;
    }
    if (commonAddition > 0 && totalGrossIncome > 0) {
        backRatio =
            (commonAddition + Number(debtPayments?.totalDebtPayments)) /
            totalGrossIncome;
    }
    if (frontRatio > 0 && backRatio > 0) {
        // setRatios({
        //     ...ratios,
        //     calculatedFrontRatio: (frontRatio * 100).toFixed(2),
        //     calculatedBackRatio: (backRatio * 100).toFixed(2),
        // });
        return { currentBackRatio: (backRatio * 100).toFixed(2) };
    }
};

export const splitUserName = (param) => {
    const name = param.split(" ");
    return {
        firstName: name[0],
        lastName: name[1]
    }
}

export const getCalculatedPercentage = (percentage) => {
    return Number(percentage)/100;
}
export const setSessionPropertyInformation = (propertyInfo) => {
    sessionStorage.setItem('propertyInfo',JSON.stringify(propertyInfo));
}
export const getSessionPropertyInformation = () => {
    return JSON.parse(sessionStorage.getItem('propertyInfo'));
}
export const  formatNumber = (value) => {
    return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value);
};
export const  formatNumberWithCommas = (num) => {
    if (!num && num !== 0) return "";
    return Number(num).toLocaleString("en-US"); // or "en-IN"
};
export const findDaysInMonth = (month) => {
    const year = new Date().getFullYear();
    // Get the number of days in the given month and year
    const daysInMonth = new Date(year, month, 0).getDate();

    // Create an array of days
    const daysArray = Array.from({ length: daysInMonth }, (_, i) => i + 1);

    return daysArray;
  }

  const calculateCombinedLoan = (mortgage, rate, tenure,firstLoanStartDate, secondMortgage, secondRate, secondTenure, secondLoanStartDate) => {
   const loan1Schedule = mortgage
    ? calculateLoanValues(mortgage, rate, tenure, firstLoanStartDate, true).yearly
    : {};
  const loan2Schedule = secondMortgage
    ? calculateLoanValues(secondMortgage, secondRate, secondTenure, secondLoanStartDate, false).yearly
    : {};

  // Merge yearly balances
  const combined = {};
  const allYears = new Set([...Object.keys(loan1Schedule), ...Object.keys(loan2Schedule)]);
  allYears.forEach(year => {
    const bal1 = loan1Schedule[year] || 0;
    const bal2 = loan2Schedule[year] || 0;
    combined[year] = bal1 + bal2;
  });

  return combined;
    };

     const calculateCombinedPrincipal = (mortgage, rate, tenure,firstLoanStartDate, secondMortgage, secondRate, secondTenure, secondLoanStartDate) => {
   const loan1Schedule = mortgage
    ? calculateLoanValues(mortgage, rate, tenure, firstLoanStartDate, true).yearlyPrincipalPaid
    : {};
  const loan2Schedule = secondMortgage
    ? calculateLoanValues(secondMortgage, secondRate, secondTenure, secondLoanStartDate, false).yearlyPrincipalPaid
    : {};

  // Merge yearly balances
  const combined = {};
  const allYears = new Set([...Object.keys(loan1Schedule), ...Object.keys(loan2Schedule)]);
  allYears.forEach(year => {
    const bal1 = loan1Schedule[year] || 0;
    const bal2 = loan2Schedule[year] || 0;
    combined[year] = bal1 + bal2;
  });

  return combined;
    };


  export const getNetWorthReportRecords = (financialList,cryptoList,comList,assetsList,assets,liabilities,portfolioList,realEstate,financials,commodities,crypto,mortgage,depletions) => {
    
    let initialReportData = [];
    let labels = [];

    const financialPrice = financials;
    const commPrice = commodities;
    const cryptoPrice = crypto;
    const currentYear = Number(moment().format("YYYY"));
    const maxYear = currentYear + 30;
    let globalTotals = {};
    portfolioList.forEach((p, idx) => {
            const combinedSchedule = calculateCombinedLoan(
            p.mortgage, p.rateOfInterest,p.amortization , p.loan?.firstLoanStartDate,
            p.secondPrincipal, p.secondRateOfInterest, p.secondAmortization , p.loan?.secondLoanStartDate
    );
    for (const [year, balance] of Object.entries(combinedSchedule)) {
        if (!globalTotals[year]) globalTotals[year] = 0;
        globalTotals[year] += balance;
        }
    });
        const depStock = depletions.find(d => d.name === "Stocks") || null;
        let startYearStock = null;
        if(depStock?.startDate != null)
            startYearStock = new Date(depStock?.startDate).getFullYear();
        const depCom = depletions.find(d => d.name === "Commodities") || null;
        let startYearCom = null;
        if(depCom?.startDate != null)
            startYearCom = new Date(depCom?.startDate).getFullYear();
        const depCrypto = depletions.find(d => d.name === "Cryptocurrency") || null;
        let startYearCrypto = null;
        if(depCrypto?.startDate != null)
            startYearCrypto = new Date(depCrypto?.startDate).getFullYear();
        let cumulativeDepletion = 0;
        for (let i = currentYear; i <= maxYear; i++) {
            let obj = {};
            obj.year = i;
            let shouldIncludeStock = startYearStock && depStock?.percentage > 0 ? i >= startYearStock : false;
            let shouldIncludeCom = startYearCom && depCom?.percentage > 0 ? i >= startYearCom : false;
            let shouldIncludeCrypto = startYearCrypto && depCrypto?.percentage > 0 ? i >= startYearCrypto : false;
            if (i === currentYear) {
                
                obj.realEstate = Number(realEstate).toFixed(2);
                
                if(shouldIncludeStock) {
                    obj.stockMarket = Number(financialPrice) - Number(financialPrice * depStock.percentage / 100 || 0);
                    cumulativeDepletion += Number(financialPrice * depStock.percentage / 100 || 0);
                }
                else
                    obj.stockMarket = Number(financialPrice);

                if(shouldIncludeCom) {
                    obj.commodities = Number(commPrice) - Number(commPrice * depCom.percentage / 100 || 0);
                    cumulativeDepletion += Number(commPrice * depCom.percentage / 100 || 0);
                }
                else
                    obj.commodities = Number(commPrice);

                if(shouldIncludeCrypto) {
                    obj.crypto = Number(cryptoPrice) - Number(cryptoPrice * depCrypto.percentage / 100 || 0);
                    cumulativeDepletion += Number(cryptoPrice * depCrypto.percentage / 100 || 0);
                }
                else
                    obj.crypto = Number(cryptoPrice);

                obj.mortgage = Number(mortgage).toFixed(2);

                let assets=0;
                let depAmount = 0;
                assetsList.forEach(asset => {
                    let assetVal = 0;
                    const amount = Number(asset?.value || 0);
                    const growth = Number(asset?.annualGrowth || 0);
                    const reinvest = !!asset?.reinvest;

                    const purchaseYear = asset?.purchaseDate
                        ? new Date(asset?.purchaseDate).getFullYear()
                        : currentYear;

                    //const years = i - purchaseYear;
                    let years = 0;
                    if(purchaseYear != null && currentYear !== purchaseYear) {
                        years= i - purchaseYear; 
                    } else {
                        years = i - currentYear;
                    }
                    
                    // With growth math
                    const valueToday = amount * Math.pow(1 + growth / 100, years);
                    if(asset.depletion) {
                    depAmount = valueToday * asset.depletion?.percentage/100;
                    cumulativeDepletion += depAmount;
                    
                    }
                    if (reinvest) {
                        const withdrawnIncome = valueToday * (asset.annualIncome / 100);
                         assets += valueToday + withdrawnIncome - depAmount;
                         assetVal = valueToday + withdrawnIncome - depAmount;
                    } else {
                        assets += valueToday - depAmount; 
                        assetVal = valueToday - depAmount;
                    }
                    obj[asset.name] = assetVal;
                });
                obj.depletion = cumulativeDepletion;
                obj.netWorth = Number((assets+realEstate+obj.stockMarket+obj.commodities+obj.crypto)-((globalTotals[i] ?? 0) + liabilities)).toFixed(2);
                initialReportData.push(obj);
            
                labels.push(Number(i));
            } else {
                let oldRecord = initialReportData.find((rd) => rd.year === i - 1);

                let yearsSinceStart = i - currentYear;
                let total = 0;
                cumulativeDepletion = 0;
                let totalAssets = 0;
                assetsList.forEach(asset => {
                    const amount = Number(asset.value || 0);
                    const growth = Number(asset.annualGrowth || 0);
                    const income = Number(asset.annualIncome || 0);
                    const reinvest = !!asset.reinvest;

                    const purchaseYear = asset.purchaseDate
                        ? new Date(asset.purchaseDate).getFullYear()
                        : currentYear;

                    //const years = i - purchaseYear;

                 
                    const yearsSinceStart =
                    purchaseYear != null && purchaseYear !== currentYear
                        ? i - purchaseYear
                        : i - currentYear;

                    // With growth math
                    //const valueToday = amount * Math.pow(1 + growth / 100, yearsSinceStart);
                     let previousYearValue = (initialReportData.find(rd => rd.year === i - 1)?.[asset.name] || 0);
                     let valueToday = previousYearValue * (1 + growth / 100);
                    let depAmount = 0;
                    let assetVal = 0;
                    let depStart = null;
                    if(asset.depletion?.startDate != null)
                        depStart = new Date(asset.depletion?.startDate).getFullYear();

                    if(asset.depletion && i >= depStart) {
                        depAmount = valueToday * asset.depletion?.percentage / 100 || 0;
                        cumulativeDepletion += depAmount;
                    }
                    if (reinvest) {
                        const withdrawnIncome = valueToday * (income / 100);
                        totalAssets += valueToday + withdrawnIncome - depAmount;
                        assetVal = valueToday + withdrawnIncome - depAmount;
                      
                    } else {
                        totalAssets += valueToday - depAmount; 
                        assetVal = valueToday - depAmount;
                    }
                    obj[asset.name] = assetVal;
                    });
                let netWorth = totalAssets;

               /* obj.netWorth = Number(
                    Number(oldRecord?.netWorth) +
                    Number(oldRecord?.netWorth) * (netWorthIncrease / 100)
                ).toFixed();*/
                
                let grandTotal = 0;
                let realEstateVal = portfolioList.map(portfolio => {
                    let pYear = portfolio.purchaseDate
                    ? new Date(portfolio.purchaseDate).getFullYear()
                    : null;  // or 0, or current year, depending on your logic
                    //for properties which are purchased earlier
                    const yearsSinceStart =
                    pYear != null && pYear !== currentYear
                        ? i - pYear
                        : i - currentYear;
                    let projectedValue = portfolio.purchasePrice * Math.pow(1 + portfolio.appreciation/100, yearsSinceStart);
                    total += projectedValue;
                    return {value: (projectedValue).toFixed() };
                });
                obj.realEstate = Math.round(total);
                netWorth = Math.round(Number(netWorth)+total);
             
                let totalStock=0;
               
                        
                shouldIncludeStock = startYearStock && depStock?.percentage > 0 ? i >= startYearStock : false;
                
         
                // eslint-disable-next-line no-unused-vars
                let stockVal = financialList.map(stock => { 
                    let projectedValue = 0;
                     let pYear = stock.purchase_date
                    ? new Date(stock.purchase_date).getFullYear()
                    : null;  // or 0, or current year, depending on your logic
                    //for properties which are purchased earlier
                    const yearsSinceStart =
                    pYear != null && pYear !== currentYear
                        ? i - pYear
                        : i - currentYear;
                    projectedValue = stock.inv_value * Math.pow(1 + stock.projected_growth/100, yearsSinceStart);
                    // Apply cumulative depletion to the total stock value for next year's opening balance
                    if (shouldIncludeStock && i >= currentYear) {
                        
                        const currentDepletion = projectedValue * depStock.percentage / 100 || 0;
                        cumulativeDepletion += currentDepletion;
                        projectedValue = projectedValue - currentDepletion;
                    }                                               
                    totalStock += projectedValue;
                    
                });
                                
                netWorth = Math.round(netWorth+totalStock);
                obj.stockMarket = Math.round(totalStock);
                
                shouldIncludeCom = startYearCom && depCom?.percentage > 0 ? i >= startYearCom : false;
                
                let totalCom = 0;
                
                let comVal = comList.map(stock => {
                   let projectedValue = 0;
                  let pYear = stock.purchase_date
                    ? new Date(stock.purchase_date).getFullYear()
                    : null;  // or 0, or current year, depending on your logic
                    //for properties which are purchased earlier
                    const yearsSinceStart =
                    pYear != null && pYear !== currentYear
                        ? i - pYear
                        : i - currentYear;
                    projectedValue = stock.inv_value * Math.pow(1 + stock.projected_growth/100, yearsSinceStart);
                    // Apply cumulative depletion to the total stock value for next year's opening balance
                    if (shouldIncludeCom && i >= currentYear) {

                        const currentDepletion = projectedValue * depCom.percentage / 100 || 0;
                        cumulativeDepletion += currentDepletion;
                        projectedValue = projectedValue - currentDepletion;
                    }
                    totalCom += projectedValue;

                });
                netWorth = Math.round(netWorth+totalCom);
                
                obj.commodities = Math.round(totalCom);

                shouldIncludeCrypto = startYearCrypto && depCrypto?.percentage > 0 ? i >= startYearCrypto : false;

                let totalCrypto = 0;
               
                 let cryptoVal = cryptoList.map(stock => {
                   let  projectedValue = 0;
                   let pYear = stock.purchase_date
                    ? new Date(stock.purchase_date).getFullYear()
                    : null;  // or 0, or current year, depending on your logic
                    //for properties which are purchased earlier
                    const yearsSinceStart =
                    pYear != null && pYear !== currentYear
                        ? i - pYear
                        : i - currentYear;
                    projectedValue = stock.inv_value * Math.pow(1 + stock.projected_growth/100, yearsSinceStart);

                    // Apply cumulative depletion to the total stock value for next year's opening balance
                    if (shouldIncludeCrypto && i >= currentYear) {

                        const currentDepletion = projectedValue * depCrypto.percentage / 100 || 0;
                        cumulativeDepletion += currentDepletion;
                        projectedValue = projectedValue - currentDepletion;
                    }
                    totalCrypto += projectedValue;
                });
                netWorth = Math.round(netWorth+totalCrypto);
                obj.crypto = Math.round(totalCrypto);
               
                obj.depletion = Math.round(cumulativeDepletion);

                obj.netWorth = netWorth - ((globalTotals[i] ?? 0) + liabilities);
             
                initialReportData.push(obj);
                
              
                labels.push(Number(i));
            }
        }
        //Calculate loan values
        let loanValues=0;
        let reportData;

        reportData = initialReportData.map((item) => {
            const year = item.year;
            const loanValue = globalTotals[year] ?? 0; // Use 0 if not found
        
            return {
                ...item,
                mortgage: String(((loanValue * 100) / 100).toFixed(2)),
            };
        });

        return { reportData, labels };
    
}
 export const getProjectedAssetValue = (value,annual_growth,reinvest, purchase_date) => {
  const currentYear = new Date().getFullYear();
  const amount = Number(value || 0);
  const growth = Number(annual_growth || 0);
  const reinvest1 = !!reinvest;


  // If purchase date missing → assume current year
  const purchaseYear = purchase_date
    ? new Date(purchase_date).getFullYear()
    : currentYear;

  const years = currentYear - purchaseYear;

  // Pure compounding
  const valueToday = amount * Math.pow(1 + growth / 100, years);

  if (reinvest1) {
    // Reinvest = TRUE → value only
    return valueToday;
  } else {
    // Reinvest = FALSE → value + withdrawn income
    const withdrawnIncome = (amount * (growth / 100)) * years;
    return amount + withdrawnIncome;
  }
}
export const buildAccountDatasets = (accounts, years) =>
  accounts.map(acc => {
    const totalValue = acc.accountCategories.reduce(
      (sum, c) => sum + Number(c.value || 0),
      0
    );

    const growth =
      acc.accountCategories.find(c => c.annualGrowth)?.annualGrowth || 5;

    return {
      label: acc.account_name,
      data: projectValues(totalValue, growth, years),
      accountId: acc.id,
      isAccount: true, 
      borderWidth: 3,
      tension: 0.35
    };
  });
  export const projectValues = (baseValue, growthRate, years) =>
  years.map((_, i) =>
    Number(
      baseValue * Math.pow(1 + growthRate / 100, i)
    ).toFixed(2)
  );
  export const buildCategoryDatasets = (account, years) =>
    account.accountCategories.map(cat => ({
        label: cat.name,                 // each category is a line
        data: projectValues(
        Number(cat.value || 0),
        cat.annualGrowth || 5,
        years
        ),
        isAccount: false,    
        categoryId: cat.id,
        borderWidth: 2,
        tension: 0.35
  }));
  export const buildSubCategoryDatasets = (cat, years) => {
    return [
    {
        label: cat.name,                 // 👈 each category is a line
        data: projectValues(
        Number(cat.value || 0),
        cat.annualGrowth || 5,
        years
        ),
        isAccount: false,    
        categoryId: cat.id,
        borderWidth: 2,
        tension: 0.35
    }
]
  }
export const getIncomeReportRecords = (
  accounts,
  propertyIncome,
  lifeEvents,
  depletions,
  userSettingsProperty,
  userSettingsInvestment,
  properties
  ) => {
  let initialReportData = [];
  let labels = [];
  const FREQUENCY_MULTIPLIER = {
    Monthly: 12,
    Quarterly: 4,
    "Half Yearly": 2,
    Annual: 1,
  };
  const currentYear = Number(moment().format("YYYY"));
  const maxYear = currentYear + 30;
  
  const depletionMap = depletions.reduce((map, d) => {
    if (!map[d.accountCategoryId]) {
      map[d.accountCategoryId] = [];
    }
    map[d.accountCategoryId].push({
      percentage: Number(d.percentage || 0),
      startYear: d.startDate ? new Date(d.startDate).getFullYear():null,
      amount: Number(d.amount || 0),
    });
    return map;
  }, {});
  
  const lifeEeventsMap = lifeEvents.reduce((map, d) => {
      if (!map[d.accountCategoryId]) {
        map[d.accountCategoryId] = [];
      }
      map[d.accountCategoryId].push({
        amount: Number(d.plannedExpense || 0),
        startYear:  d.plannedDate ?  new Date(d.plannedDate).getFullYear():null,
      });
      return map;
    }, {});

  let assets = accounts.flatMap((account) =>
    (account.accountCategories || []).map((cat) => {
      const purchaseYear = cat.purchaseDate ? new Date(cat.purchaseDate).getFullYear() : currentYear;
      const yearsFromPurchase = currentYear - purchaseYear;
      const projectedValue = cat.value * Math.pow(1 + (cat.annualGrowth || 0) / 100, yearsFromPurchase);
      return {
        initialValue: Number(cat.value || 0),
        value: Number(projectedValue || 0),
        incomeRate: Number(cat.annualIncome || 0) / 100,
        growthRate: Number(cat.annualGrowth || 0) / 100,
        reinvest: cat.reinvest || false,
        depletions: depletionMap[cat.id] || [],
        lifeEvents:lifeEeventsMap[cat.id] || [],
        name: account.account_name,
        cat_name: cat.name,
        purchaseDate: cat.purchaseDate,
        propertyType: cat.propertyType || null,
      };
    })
  );
  
  const initialBalance = accounts
    .flatMap((a) => a.accountCategories || [])
    .reduce((sum, c) => sum + Number(c.value || 0), 0);
  let globalTotals = {};
  properties.forEach((p, idx) => {
    const combinedSchedule = calculateCombinedPrincipal(
      p.mortgage,
      p.rateOfInterest,
      p.amortization,
      p.loan?.firstLoanStartDate,
      p.secondPrincipal,
      p.secondRateOfInterest,
      p.secondAmortization,
      p.loan?.secondLoanStartDate
    );

    for (const [year, balance] of Object.entries(combinedSchedule)) {
      if (!globalTotals[year]) globalTotals[year] = 0;
      globalTotals[year] += balance;
    }
  });

  let portfolioBalance = initialBalance;
  // Year-wise loop
  for (let i = currentYear; i <= maxYear; i++) {
    let obj = {};

    const yearsSinceStart = i - currentYear;
   
   
    let openingBalance =
      assets.length > 0
        ? assets.reduce((sum, a) => sum + a.value, 0)
        : portfolioBalance;

    let income = 0;
    let incomeBreakup = {};
    let growth = 0;
    let depletion = 0;

    let life = 0;
    let reinvestedIncome = 0;
    let plannedExpensesForYear = 0;

    const totals = propertyIncome?.reduce(
      (acc, item) => {
        acc.totalIncome += Number(item.totalIncome || 0);
        acc.expenses += Number(item.expenses || 0);
        acc.rental += Number(item.rentIncome || 0);
        acc.hoa += (item.hoa || 0);
        acc.homeWarranty += (item.homeWarranty || 0);
        acc.insurance += (item.insurance || 0);
        acc.propertyTax += (item.propertyTaxes || 0);
        acc.mortgage += (item.mortgage || 0);
        return acc;
      },
      { totalIncome: 0, expenses: 0 , rental: 0, hoa : 0, homeWarranty: 0, insurance: 0, propertyTax: 0, mortgage: 0}  
    );
 
    // Per-asset calculations
    assets.forEach((asset) => {
      
        let pYear = asset.purchaseDate
            ? new Date(asset.purchaseDate).getFullYear()
            : null; 
            
        //for properties which are purchased earlier
        const yearsSinceStart =
        pYear != null && pYear !== currentYear
            ? i - pYear
            : i - currentYear;
      
        let previousYearValue = i === currentYear ? asset.value : (initialReportData.find(rd => rd.year === i - 1)?.[asset.cat_name] || 0);
        let currentValue = i === currentYear ? asset.value : previousYearValue * (1 + asset.growthRate);
        let depAmount = 0;          
      if (asset.depletions.length > 0) {
        const startYear = asset.depletions[0]?.startYear;
        
        const shouldInclude = startYear && asset.depletions[0]?.percentage > 0 ? i >= startYear : false;
       
        if (shouldInclude) {
            depAmount = (currentValue * asset.depletions[0]?.percentage) / 100;
          depletion += depAmount;
        }
       
    }
       obj[asset.cat_name] = currentValue - depAmount;
       /*if(asset.name === "Property") {
            const propIncome = totals?.rental * rentalIncreaseFactor;
            income += propIncome;
            incomeBreakup["Property"] = (incomeBreakup["Property"] || 0) + propIncome;
            reinvestedIncome += propIncome;
           
        } else {*/
            const assetIncome = (currentValue - depAmount) * asset.incomeRate;
            if(!asset.reinvest) {
                income += assetIncome;
                incomeBreakup[asset.name] = (incomeBreakup[asset.name] || 0) + assetIncome;
            } else {
                reinvestedIncome += assetIncome;
                
            }

      //  }
       
       growth += currentValue * asset.growthRate;
    
    
    });
   
    propertyIncome.forEach((property) => {
        let pYear = property.purchaseDate
            ? new Date(property.purchaseDate).getFullYear()
            : null; 
            
        //for properties which are purchased earlier
        const yearsSinceStart =
        pYear != null && pYear !== currentYear
            ? i - pYear
            : i - currentYear;

        const propertyTaxIncrease = property.portfolioType === "property" ? Number(userSettingsProperty?.increasePropertyTax) || 0 : Number(userSettingsInvestment?.increaseInPTax) || 0;
        const propertyTaxIncreaseFactor = Math.pow(1 + propertyTaxIncrease / 100, yearsSinceStart);
        const inflation = property.portfolioType == "property" ? Number(userSettingsProperty?.inflationRate) || 0 : Number(userSettingsInvestment?.inflationRate) || 0;
        plannedExpensesForYear += property?.hoa * Math.pow(1 + inflation / 100, yearsSinceStart);
        plannedExpensesForYear += property?.homeWarranty * Math.pow(1 + inflation / 100, yearsSinceStart);
        plannedExpensesForYear += property?.insurance * Math.pow(1 + inflation / 100, yearsSinceStart);
        plannedExpensesForYear += property?.propertyTaxes * propertyTaxIncreaseFactor;
        plannedExpensesForYear += property?.mortgage;

        let rentStartYear = property.rentStartDate
            ? new Date(property.rentStartDate).getFullYear()
            : null; 
            
        //for properties which are purchased earlier
        const yearsSinceRentStart =
            rentStartYear != null && rentStartYear !== currentYear
                ? i - rentStartYear
                : i - currentYear;

        const rentalIncrease = property.rentalIncrease;
        
        // Only include rental income if rent has started
        if (rentStartYear != null && i >= rentStartYear) {
            const rentalIncreaseFactor = Math.pow(1 + rentalIncrease / 100, yearsSinceRentStart);
            const propIncome = property?.rentIncome * rentalIncreaseFactor;
            income += propIncome;
            incomeBreakup["Property"] = (incomeBreakup["Property"] || 0) + propIncome;
            reinvestedIncome += propIncome;
        }
    });
    
     life = lifeEvents.reduce(
          (sum, d) =>{
            const frequency = d.frequency || "annual";
            const inflation = Number(userSettingsProperty?.inflationRate) || 0;
            let pYear = d.plannedDate
            ? new Date(d.plannedDate).getFullYear()
            : null; 
            
            //for properties which are purchased earlier
            const yearsSinceStart =
            pYear != null && pYear !== currentYear
                ? i - pYear
                : i - currentYear;

            const multiplier = FREQUENCY_MULTIPLIER[frequency] ?? 1;
            const startYear = new Date(d.plannedDate).getFullYear();
            const endYear = d.completionDate
                ? new Date(d.completionDate).getFullYear()
                : null;

            // Calculate inflation factor - ensure it's at least 1 (no negative inflation)
            const inflationFactor = Math.pow(1 + Math.max(0, inflation) / 100, Math.max(0, yearsSinceStart));

            if (d.selectedOption === "One Time") {
                // only include in the planned year, once - apply inflation for one-time expenses
                if (i === startYear) {
                return sum + (Number(d.plannedExpense) || 0) * inflationFactor;
                }
                return sum; // no expense in other years
            }

            const shouldInclude = endYear
                ? i >= startYear && i <= endYear   // range
                : i >= startYear;                 // only start year

              if (!shouldInclude) return sum;
              
              // Apply inflation to recurring expenses
              const baseExpense = Number(d.plannedExpense) || 0;
              const inflatedExpense = baseExpense * multiplier * inflationFactor;
              
              return sum + inflatedExpense;
          },0
        );
   
    
    
    // 4️⃣ Portfolio closing balance
  //  const closingBalance =
   //   openingBalance + reinvestedIncome + growth - plannedExpensesForYear - depletion - life; 

    //obj.openingBalance = Math.round(openingBalance);
    obj.income = Math.round(income);
    obj.incomeBreakup = incomeBreakup;
    obj.growth = Math.round(growth);
    obj.plannedExpenses = plannedExpensesForYear + life;
    obj.depletion = depletion;
    obj.principal = globalTotals[i] ?? 0;   

    const excluded = ["Brokerage Accounts", "Property"];

    const otherIncome = Object.entries(incomeBreakup)
    .filter(([key]) => !excluded.includes(key))
    .reduce((sum, [, value]) => sum + (value ?? 0), 0);

    obj.brokerageIncome = incomeBreakup["Brokerage Accounts"];
    obj.propertyIncome =  incomeBreakup["Property"];
    obj.otherIncome = otherIncome;
    //obj.closingBalance = Math.round(closingBalance);
    obj.surplus = Math.round((obj.brokerageIncome? obj.brokerageIncome:0) +(obj.propertyIncome?obj.propertyIncome:0) + (obj.otherIncome?obj.otherIncome:0) + (depletion?depletion:0) - (obj.plannedExpenses?obj.plannedExpenses:0) );
    obj.year = i;
    // 5️⃣ Store report row
    initialReportData.push(obj);

   // portfolioBalance = closingBalance;
   
    // 6️⃣ Carry forward balances (income reinvested)
   /* if (assets.length > 0) {
      assets = assets.map((asset,index) => {
        let incomeAsset = 0;
           let pYear = asset.purchaseDate
            ? new Date(asset.purchaseDate).getFullYear()
            : null; 
            
        //for properties which are purchased earlier
        const yearsSinceStart =
        pYear != null && pYear !== currentYear
            ? i - pYear
            : i - currentYear;

           let currentValue = Number(
                asset.initialValue * Math.pow(1 + asset.growthRate, yearsSinceStart)
                ).toFixed(2);
          const rentalIncrease = asset.name !== "property" || (asset.name === "Property" && asset.propertyType === "property") ? Number(userSettingsProperty?.rentalIncrease) || 0 : Number(userSettingsInvestment?.rentalIncrease) || 0;
            const rentalIncreaseFactor = Math.pow(1 + rentalIncrease / 100, yearsSinceStart);
         if(asset.name === "Property") {
            incomeAsset += totals?.rental * rentalIncreaseFactor;
           
        } else {
            if(!asset.reinvest) {
                incomeAsset = 0;
                
            } else {
                incomeAsset += currentValue * asset.incomeRate;
            }
        }
        const growthAsset = currentValue * asset.growthRate;

        let c = 0 ;
        c = asset.value + incomeAsset + growthAsset - plannedExpensesForYear;
       
        return {
          ...asset,
          value:
      asset.value +
      incomeAsset +
      growthAsset -
      (index === 0 ? plannedExpensesForYear : 0) - 
       (index === 0 ? life : 0) - 
       (index === 0 ? depletion : 0),
        };
      });
     
    }*/
  
    labels.push(Number(i));
}

  

  return { initialReportData, labels };
};


  
